var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.events && _vm.events.length)?_c('div',[_c('table-blue',{attrs:{"cols":_vm.cols}}),_c('table-blue-label-count',{attrs:{"amount":_vm.events.length}})],1):_c('table-blue-no-result')}
var staticRenderFns = []

export { render, staticRenderFns }